import * as React from 'react';
import { InputProps, Input, InputRefs } from '@tcl-boron-foundations/input';
import { Close } from '@tcl-argon-icons/icons';
import { KeyboardEventHandler, MouseEventHandler } from 'react';
import { BaseInputProps } from '@tcl-argon-models/models';
import { ActionPalette } from '@tcl-boron-colors/colors';
export interface TextInputProps extends Omit<BaseInputProps, 'theme'>, Omit<InputProps, 'onChange'> {
  /** A handler called whenever this input changes. The new value is passed as the only argument to the callback. */
  onChange: (value: string) => void;
  /** The text value of this component */
  value: string;
  /** style will change on input based on inputType */
  inputType?: 'primary' | 'secondary';
  /** boolean if true will provide clear button for text input */
  clearable?: boolean;
}

export const TextInput = React.forwardRef<InputRefs, TextInputProps>(function TextInput(
  { onChange, inputType = 'primary', clearable = false, ...props },
  ref,
) {
  const clearInput: MouseEventHandler<HTMLDivElement> = () => {
    onChange('');
  };

  const clearInputKeyPress: KeyboardEventHandler<HTMLDivElement> = () => {
    onChange('');
  };
  return (
    <Input
      // This assertion forces compliance.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ref={ref as any}
      isPrimary={inputType === 'primary' ? true : false}
      onChange={(e) => onChange(e.target.value)}
      aria-disabled={props.disabled}
      clearable={
        clearable ? (
          <div style={{ cursor: 'pointer' }} onKeyPress={clearInputKeyPress} tabIndex={0} onClick={clearInput}>
            <Close color={ActionPalette[600]} />
          </div>
        ) : null
      }
      {...props}
    />
  );
});
